import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const CardPlayIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.30546 1C8.20089 1 7.30546 1.89543 7.30546 3V15.5C7.30546 16.6046 8.20076 17.5 9.30533 17.5C11.1829 17.5 13.7803 17.5 14.3085 17.5L15.7552 16.0888L14.868 15.2016C13.794 14.1276 13.794 12.3865 14.868 11.3125C15.8017 10.3787 17.24 10.2568 18.3055 10.9469V3C18.3055 1.89543 17.41 1 16.3055 1H9.30546ZM11 3L9 6L11 9L13 6L11 3Z"
      fill={color}
    />
    <path
      d="M1.40273 9.86843L2.29222 8.97893L7.37865 17.7889L1.40273 11.8129C0.865757 11.276 0.865757 10.4054 1.40273 9.86843Z"
      fill={color}
    />
    <path
      d="M17.712 16.101L14.868 18.875V21C14.868 22.1046 15.7634 23 16.868 23H20.4305C21.535 23 22.4305 22.1046 22.4305 21V14.3961C22.4305 13.3022 21.9959 12.2529 21.2223 11.4793L19.6805 9.9375V14.1804L17.7848 12.2848C17.2478 11.7477 16.3772 11.7477 15.8402 12.2848C15.3033 12.8217 15.3033 13.6923 15.8402 14.2293L17.712 16.101Z"
      fill={color}
    />
    <path
      d="M3.68374 5.8125L5.93046 4.51538V12.4539L3.18046 7.69079C2.80076 7.03316 3.02609 6.19217 3.68374 5.8125Z"
      fill={color}
    />
    <path
      d="M9.63764 18.875L10.0555 19.5987C10.4352 20.2563 11.2761 20.4816 11.9337 20.102L14.0589 18.875H9.63764Z"
      fill={color}
    />
  </svg>
);
